import React, {useEffect, useState} from "react";
import { createPortal } from "react-dom";
import {
    CloseIcon,
} from "../../helper/HwIcon";
import {
    CardNumberElement,
    CardExpiryElement,
    CardCvcElement,
    useStripe,
    useElements,
  } from "@stripe/react-stripe-js";
import {useSelector} from "react-redux";
import {formatePriceFn, formatPrice} from "../../helper/commonFunction";
import AedChargeNote from "../../component/AedChargeNote";

function OnlineStripePopup({ show, setShow, totalAmount, onPaymentSuccess, agentActiveCurrency = "AED" , onClose,clientSecret,displayPrice }) {

    const stripe = useStripe();
    const elements = useElements();
    const { userAgentData, agentActiveCurrency: reduxCurrency, displayPrice: reduxDisplayPrice } = useSelector((state) => state.userData);
    const effectiveCurrency = (agentActiveCurrency && agentActiveCurrency !== "AED")
        ? agentActiveCurrency
        : (reduxCurrency || agentActiveCurrency || "AED");
    const effectiveDisplayPrice = displayPrice !== undefined ? displayPrice : (reduxDisplayPrice || 0);
    const [loading, setLoading] = useState(false);
    const [error, setError] = useState("");
    const [paymentError, setPaymentError] = useState("");
    const [paymentErrors, setPaymentErrors] = useState({
        cardElement: {
            complete: false,
            error: null,
            empty: true,
        },
        expiryElement: {
            complete: false,
            error: null,
            empty: true,
        },
        cvcElement: {
            complete: false,
            error: null,
            empty: true,
        },
    });

    const handleValidateValues = (element,event) => {
        setPaymentErrors({
            ...paymentErrors,
            [element]: {
                complete: event?.complete,
                error: event?.error?.message,
                empty: event?.empty,
            },
        });
    }

    useEffect(() => {
        setPaymentError('');
    },[])

    const handlePayNow = async (e) => {
        setPaymentError('')
        e.preventDefault();
        setLoading(true);
        setError("");

        if (!stripe || !elements) {
            setError("Stripe has not loaded yet.");
            setLoading(false);
            return;
        }

        const cardElement = elements.getElement(CardNumberElement);

        if (paymentErrors.cardElement.empty || paymentErrors.expiryElement.empty || paymentErrors.cvcElement.empty) {
            setError("Please fill all the fields.");
            setLoading(false);
            return;
        }
        if (!paymentErrors.cardElement.complete || !paymentErrors.expiryElement.complete || !paymentErrors.cvcElement.complete) {
            setLoading(false);
            return;
        }

        if (!cardElement) {
            setError("Card element not found.");
            setLoading(false);
            return;
        }

        try {
            const { paymentIntent, error } = await stripe.confirmCardPayment(
                clientSecret,
                {
                    payment_method: {
                        card: cardElement,
                        billing_details:{
                            name: userAgentData?.user_data?.display_name || "Test User"
                        }
                    }
                }
            );

            if(error){
                setPaymentError(error?.message)
                return false;
            }

            if (onPaymentSuccess && paymentIntent && paymentIntent.status === "requires_capture") {
                onPaymentSuccess(paymentIntent);
            }
            setShow(false);
        } catch (err) {
            setError("Payment failed. Please try again.");
        } finally {
            setLoading(false);
        }
    };

    return createPortal(
        <>
            <div className={`hw-modal fade ${show ? "show" : ""}`}>
                <div className="hw-modal-dialog hw--online-stripe-payment-popup hw-modal-dialog-centered hw-modal-dialog-scrollable fbd-stripe-dialog">
                    <div className="hw-modal-content fbd-stripe">
                        <div className={`hw-modal-header `}>
                            <div className="hw-modal-headerTitle">Complete Your Payment</div>
                            {/*<button
                                onClick={() => {
                                    setShow(false);
                                    onClose();
                                }}
                                className="hw-modal--close"
                            >
                                <CloseIcon />
                            </button>*/}
                        </div>
                        <div className="hw-modal-body">
                            <div className="hw-payment--container d-flex d-flex-column hw-gapx16">
                                <div className="row">
                                    <div className="col-md-12">
                                        <label className="hw-label hw-fontWeight--500 hw-black900 d-block">
                                            Card number
                                        </label>
                                        <div className={`hw-form--input hw-stripe-input ${paymentErrors.cardElement.error ? 'is-error' : ''}`}>
                                            <CardNumberElement
                                                onChange={(e)=>{
                                                    handleValidateValues("cardElement",e)
                                                }}
                                                options={{
                                                    showIcon:true,
                                                    style: {
                                                        base: {
                                                            fontSize: '16px',
                                                            color: '#424770',
                                                            '::placeholder': {
                                                                color: '#aab7c4',
                                                            },
                                                            fontSmoothing: 'antialiased',
                                                        },
                                                        invalid: {
                                                            color: '#d92d20',
                                                            iconColor: '#d92d20'
                                                        },
                                                    },
                                                }}
                                            />
                                        </div>
                                        {paymentErrors.cardElement.error && (
                                            <p className="hw-p-error-cls mt-1">
                                                {paymentErrors.cardElement.error}
                                            </p>
                                        )}
                                    </div>
                                </div>

                                <div className="row">
                                    <div className="col-md-6">
                                        <label className="hw-label hw-fontWeight--500 hw-black900 d-block">
                                            Expiration date
                                        </label>
                                        <div className={`hw-form--input hw-stripe-input ${paymentErrors.expiryElement.error ? 'is-error' : ''}`}>
                                            <CardExpiryElement
                                                onChange={(e)=>{
                                                    handleValidateValues("expiryElement",e)
                                                }}
                                                options={{
                                                    style: {
                                                        base: {
                                                            fontSize: '16px',
                                                            color: '#424770',
                                                            '::placeholder': {
                                                                color: '#aab7c4',
                                                            },
                                                            fontSmoothing: 'antialiased',
                                                        },
                                                        invalid: {
                                                            color: '#d92d20',
                                                            iconColor: '#d92d20'
                                                        },
                                                    },
                                                }}
                                            />
                                        </div>
                                        {paymentErrors.expiryElement.error && (
                                            <p className="hw-p-error-cls mt-1">
                                                {paymentErrors.expiryElement.error}
                                            </p>
                                        )}
                                    </div>
                                    <div className="col-md-6">
                                        <label className="hw-label hw-fontWeight--500 hw-black900 d-block">
                                            Security code
                                        </label>
                                        <div className={`hw-form--input hw-stripe-input ${paymentErrors.cvcElement.error ? 'is-error' : ''}`}>
                                            <CardCvcElement
                                                onChange={(e)=>{
                                                    handleValidateValues("cvcElement",e)
                                                }}
                                                options={{
                                                    style: {
                                                        base: {
                                                            fontSize: '16px',
                                                            color: '#424770',
                                                            '::placeholder': {
                                                                color: '#aab7c4',
                                                            },
                                                            fontSmoothing: 'antialiased',
                                                        },
                                                        invalid: {
                                                            color: '#d92d20',
                                                            iconColor: '#d92d20'
                                                        },
                                                    },
                                                }}
                                            />
                                        </div>
                                        {paymentErrors.cvcElement.error && (
                                            <p className="hw-p-error-cls mt-1">
                                                {paymentErrors.cvcElement.error}
                                            </p>
                                        )}
                                    </div>
                                </div>

                                {error && (
                                    <p className="hw-p-error-cls">
                                        {error}
                                    </p>
                                )}

                                {paymentError ? <span className="hw-p-error-cls">{paymentError}</span> : ''}

                                <div className="hw-payment--summary d-flex justify-between align-items-center">
                                    <div>
                                        <span className="hw-text18 hw-fontBold hw-brand-blue">Total</span>
                                    </div>
                                    <span className="hw-text20 hw-fontBold hw-black900">{formatePriceFn(effectiveCurrency , formatPrice(totalAmount,false,false,true), effectiveDisplayPrice)}</span>
                                </div>
                                {/* {formatePriceFn(effectiveCurrency , formatPrice(onlineServiceFeeAmount,false,false,true), effectiveDisplayPrice)} */}
                                <AedChargeNote amount={totalAmount} currencyCode={effectiveCurrency} />
                                <div className="hw-payment--actions">
                                    <button
                                        className="hw-btn hw-btn--primary hw-btn--mdSize w-100"
                                        onClick={handlePayNow}
                                        disabled={loading}
                                    >
                                        {loading ? (
                                            <span style={{minWidth: '2.8rem', minHeight: "2.8rem"}} className='hw-main--loaderCommon'/>
                                        ) : (
                                            'Pay Now'
                                        )}
                                    </button>
                                    <button
                                        className="hw-btn hw-btn--primaryOutline  hw-btn--mdSize w-100"
                                        onClick={() => {
                                            setShow(false);
                                            onClose();
                                        }}
                                    >
                                        Cancel Payment
                                    </button>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            {show ? <div className="hw-modal-backdrop fade show" /> : ""}
        </>,
        document.body
    );
}

export default OnlineStripePopup;
